import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { OrderMatchIntelligenceSummaryDto } from '../../../_core/_model/machine-learning';
import { MachineLearningAdminService } from '../../../_core/_services/machine-learning-admin.service';

@Component({
  selector: 'app-admin-ml-matching',
  standalone: false,
  templateUrl: './admin-ml-matching.html',
  styleUrl: './admin-ml-matching.css'
})
export class AdminMlMatching implements OnInit {
  loading = false;
  error = '';
  fromDate = '';
  toDate = '';
  summary: OrderMatchIntelligenceSummaryDto | null = null;

  constructor(private mlService: MachineLearningAdminService) {}

  ngOnInit(): void { this.load(); }

  load(): void {
    this.loading = true;
    this.error = '';
    this.mlService.getMatchingIntelligenceSummary(this.fromDate || null, this.toDate || null).subscribe({
      next: response => {
        this.summary = response.data;
        this.loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.error = error.error?.error?.details || error.error?.message || error.message || 'Unable to load matching intelligence.';
        this.loading = false;
      }
    });
  }

  agreementClass(value: number): string {
    if (value >= 85) return 'text-success';
    if (value >= 65) return 'text-warning';
    return 'text-danger';
  }
}
